import gql from "graphql-tag";

export const GET_DEAL_STATUS = gql`
  query dealStatuses{
    statuses: DealStatuses{
      id
      status
    }
  }
`

export const GET_DEAL_NOTE = gql`
query($id:uuid!){
 Deals(where:{id:{_eq:$id}}){
  id
  note        
 }
}`